import React, { useState, useEffect } from 'react';
import Page from 'src/components/Page';
import {
  Alert,
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Pagination,
  PaginationItem,
  Paper,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography
} from '@mui/material';
import {
  LoadingButton,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineSeparator,
  Timeline
} from '@mui/lab';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import Iconify from 'src/components/Iconify';
import { useLocation, useNavigate } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import Messagebox from 'src/components/home/Messagebox';
import { api } from 'src/Api';

export default function HistoryMessage() {
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem('token');
  const user = localStorage.getItem('user');
  const userData = JSON.parse(user);
  const { service_id, service_name, sub_service_id, sub_service_name, customer_id } =
    location.state || {};
  console.log('🚀 ~ Message ~ sub_service_id:', customer_id);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [message, setMessage] = useState('');
  const [loading, setloading] = useState(false);
  const [openCommunication, setopenCommunication] = useState(false);
  const [isGetMessage, setisGetMessage] = useState(false);

  return (
    <Page title={`Message | ${process.env.REACT_APP_PROJECTNAME}`}>
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Stack direction="row" alignItems="center">
            <IconButton
              style={{
                marginRight: 12,
                height: 40,
                width: 70,
                borderRadius: 5,
                backgroundColor: 'rgba(249, 0, 1,0.1)'
              }}
              onClick={() => navigate(-1)}
            >
              <Iconify icon="ion:return-up-back" style={{ fontSize: 25, color: '#f90001' }} />
            </IconButton>

            <Typography variant="h4" sx={{ color: '#f90001' }}>
              Message
            </Typography>
          </Stack>
        </Stack>

        <Messagebox customer_id={customer_id} getMessage={isGetMessage} />
      </Container>
    </Page>
  );
}
